// extracted by mini-css-extract-plugin
export default {"slide":"styles_slide__RBhow"};